import { Vue, Component } from 'vue-property-decorator';
import { Form } from 'element-ui';
import { ILOGPRE } from '@/types/base.d';
import { ISetting } from '@/types/set.d';

@Component
export default class formMixin extends Vue {
  public log: ILOGPRE = {
    name: '活动海报 - 模态框',
    component: 'set/activityBanner/components/bModal',
  };

  public form: any = {
    title: '',
    from: '',
    files: [],
  }

  public loading: boolean = false;

  public $refs!: {
    form: Form,
  };

  private rules: any = {
    title: [
      { required: true, message: '名称不能为空' },
    ],
    from: [
      { required: true, message: '类别不能为空' },
    ],
  };

  /* eslint-disable class-methods-use-this */
  reset(close: boolean, refrsh: boolean) {}

  /**
   * @author liangyongmou
   * @desc 重置表单
   * @param 空
   */
  resetForm() {
    this.$refs.form.resetFields();
  }
}
